module.exports = "<demo-account-indicator portfolio=\"ctrl.brief\"></demo-account-indicator>\n{{ctrl.brief.number}} {{ctrl.brief.name}}";